module.exports = __webpack_public_path__ + "img/ai.e2f7ab23.png";